// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".arrivals-dropdown[data-v-77923159] .buttons-wrapper{width:100%}.arrivals-dropdown .arrivals-toggle[data-v-77923159]{width:200px}@media(max-width: 1199.98px){.arrivals-dropdown .arrivals-toggle[data-v-77923159]{width:220px}}", ""]);
// Exports
module.exports = exports;
